import { Navigate } from "react-router-dom";
import { isAdminLoggedIn } from "../services/localStorage";

const ProtectedRoute = ({ children }) => {
    if (!isAdminLoggedIn()) {
        return <Navigate to="/" replace />;
    }

    return children;
};

export default ProtectedRoute;
